"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConfetti = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const client_1 = require("react-dom/client");
const ImageConfetti_1 = require("./ImageConfetti");
exports.useConfetti = (options) => {
    const runAnimation = react_1.useCallback(() => {
        // add container element to the dom to hold the confetti canvas
        const confettiRoot = document.createElement('div');
        document.body.append(confettiRoot);
        return new Promise(resolve => {
            // create a new confetti element
            const component = React.createElement(ImageConfetti_1.ImageConfetti, Object.assign({ runAnimation: true, onAnimationCompleted: () => {
                    if (confettiRoot) {
                        document.body.removeChild(confettiRoot);
                    }
                    resolve();
                } }, options));
            // render the element in the container
            client_1.createRoot(confettiRoot).render(component);
        });
    }, [options]);
    return {
        runAnimation,
    };
};
//# sourceMappingURL=useConfetti.js.map